/**
 * Roles (users.role): 'admin' | 'manager' | 'user'
 *
 * - admin — Smardie platform only (e.g. admin@smardie.com). Global catalog: default tasks, categories,
 *   default products/materials. No Stripe onboarding path.
 * - manager — Company account owner: billing (Stripe), invites workers, company settings & custom content.
 * - user — Invited worker: uses the app under the company; typically no billing/settings ownership.
 *
 * Legacy numeric profile.type (owner / office / onsite / …) is no longer used.
 */
export default {
  isAuthenticated: state => {
    return state.authenticated
  },
  getProfile: state => {
    return state.profile
  },
  /** Smardie platform staff — role `admin` only. */
  isPlatformAdmin: state => {
    return !!(state.profile && state.profile.role === 'admin')
  },
  /** @deprecated Use isPlatformAdmin. Kept for backwards compatibility. */
  isAdmin: (state, getters) => getters.isPlatformAdmin,
  /** Same as isPlatformAdmin (alias). */
  isSuperAdmin: (state, getters) => getters.isPlatformAdmin,
  /** Edit global default task catalog — same as platform admin. */
  isCatalogEditor: (state, getters) => getters.isPlatformAdmin,
  /** Company purchaser / owner (Stripe, invites). */
  isManager: state => {
    return !!(state.profile && state.profile.role === 'manager')
  },
  /** Invited worker. */
  isStaffUser: state => {
    return !!(state.profile && state.profile.role === 'user')
  },
  /** On-Site access only — restricted account/display settings. */
  isOnSiteStaff: state => {
    return !!(state.profile && state.profile.access_type === 'on_site')
  },
  /** Can list, invite, and manage company users (not On-Site). */
  canManageAccountUsers: state => {
    const profile = state.profile
    if (!profile) return false
    if (profile.role === 'admin' || profile.role === 'manager') return true
    const accessType = profile.access_type
    return accessType === 'manager' || accessType === 'owner' || accessType === 'office'
  },
  canManageCompany: state => {
    return !!(state.profile && state.profile.role === 'manager')
  },
  /** Creating/editing company-owned catalog content (not global defaults). Managers + platform admin. */
  canCreateContent: state => {
    const r = state.profile && state.profile.role
    return r === 'manager' || r === 'admin'
  },
  hasActiveSubscription: state => {
    return state.subscription.active
  },
  getSubscription: state => {
    return state.subscription
  },
  isLoginInProgress: state => {
    return state.isLoginInProgress
  },
  pendingAccountSelection: state => {
    return !!state.pendingAccountSelection
  }
}
